module.exports = __webpack_public_path__ + "img/gard_horizontal_2.b160f2a2.png";